import { render, staticRenderFns } from "./DeskDetails.vue?vue&type=template&id=5101e8da&scoped=true&"
import script from "./DeskDetails.vue?vue&type=script&lang=js&"
export * from "./DeskDetails.vue?vue&type=script&lang=js&"
import style0 from "./DeskDetails.vue?vue&type=style&index=0&id=5101e8da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5101e8da",
  null
  
)

export default component.exports